import { useStore } from 'react-redux';

import { getPlatformURL } from 'src/shared/app/base/settings/appSettings';

export default function usePlatformURL(): string {
  return getPlatformURL(useStore().getState());
}
